'use strict';

const _ = require('underscore');
const Backbone = require('backbone');

const KIND_ID_SEPARATOR = ':';
const PAIR_SEPARATOR = '/';
const digitRegexp = /^\d+$/;
const isDigit = function(s) {
    return s.match(digitRegexp);
};

class Key extends Backbone.Model {
    initialize(key) {
        if(_.isString(key)) {
            this._pairs = this.key2pairs(key);
            this._key = key;
        } else {
            this._pairs = key;
            this._key = this.pairs2key(key);
        }
        this._lastPair = _.last(this._pairs);
        // Model の id に Key String を設定することで Collection で扱いやすくする
        this.set('id', this._key);
    }

    key2pairs(keyString) {
        if(keyString.indexOf(KIND_ID_SEPARATOR) < 0) {
            throw `Invalid Key String: ${keyString}`;
        }

        return _.map(keyString.split(PAIR_SEPARATOR), pairString => {
            const pair = pairString.split(KIND_ID_SEPARATOR);
            if(pair.length != 2) {
                throw `Invalid Pair: ${pairString}`;
            }

            const kind = pair[0];
            let id = pair[1];

            if(isDigit(id)) {
                id = parseInt(id);
            }

            return [kind, id];
        });
    }

    pairs2key(pairs) {
        return _.map(pairs, p => `${p[0]}:${p[1]}`).join('/');
    }

    get id() {
        return this._lastPair && this._lastPair[1];
    }

    get kind() {
        return this._lastPair && this._lastPair[0];
    }

    get parent() {
        return new Key(_.initial(this._pairs));
    }

    isEqual(other) {
        return this.toString() === other.toString();
    }

    toString() {
        return this._key;
    }

    toUrlsafeString() {
        return encodeURIComponent(this.toString());
    }
}

module.exports = Key;



// WEBPACK FOOTER //
// ./common/domain/value/key.js